// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"239":"7e34d5b0","455":"90655fe3","977":"da205627"}[chunkId] + ".chunk.js";
};